var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38726 15.1288C0.763809 14.5833 0.700633 13.6357 1.24616 13.0122L5.63187 7.99998L1.24616 2.98774C0.700634 2.36428 0.76381 1.41664 1.38726 0.871115C2.01072 0.325592 2.95836 0.388767 3.50389 1.01222L8.75389 7.01222C9.24873 7.57776 9.24873 8.4222 8.75388 8.98774L3.50389 14.9877C2.95836 15.6112 2.01072 15.6744 1.38726 15.1288Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.svg";
export { ForwardRef as ReactComponent };